import { render, staticRenderFns } from "./ProdutoConsumo.vue?vue&type=template&id=a0ddc79a&scoped=true"
import script from "./ProdutoConsumo.vue?vue&type=script&lang=js"
export * from "./ProdutoConsumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ddc79a",
  null
  
)

export default component.exports